
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import "../../assets/scss/autocomplete.scss";
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import fire from '../../config/firebase';
import Moment from 'moment';
const filter = createFilterOptions();

export default function AddChips(props) {
  const [value, setValue] = React.useState(null);
  const { allTags = [] } = props;
  const set = new Set();
  const tempAllTags = [];
  for (const tag of allTags) {
    const curKey = (tag.title || '').toLowerCase()
    if (set.has(curKey) === false) {
      tempAllTags.push(tag);
      set.add(curKey);
    }
  }
  let inputLength = 0;

  const addNewItem = (name) => {
    Object.filter = (obj, predicate) =>
      Object.keys(obj)
        .filter(key => predicate(obj[key]))
        .reduce((res, key) => (res[key] = obj[key]), {});

    const listRef = fire.database().ref("tags");
    const itemData = {
      title: name,
      date: Moment(new Date()).format('DD/MM/YYYY'),
      borderColor: "#fffff"
    }
    listRef.once('value', (snap) => {
      if (itemData) {
        const listDb = snap.val();

        const keys = Object.keys(listDb);
        const filteredList = [];
        for (const key of keys) {
          const item = listDb[key];

          if (item.title !== name) {
            filteredList.push(itemData);
          }
        }
        if (filteredList.length) {

          listRef.push(itemData);
          if (props.refreshData) {
            props.refreshData();
          }
        }
      }
      // listRef.off('value');
    })
  }
  function capitalizeFirstLetter(str = "") {
    return str && str.length > 0 ? str.charAt(0).toUpperCase() + str.slice(1) : str;
  }
  return (
    <Autocomplete
      value={value}
      className={props.cla + ' ' + props.classes}
      onChange={(event, newValue) => {
        if (typeof newValue === 'string') {
          setValue({
            title: newValue,
          });
        } else if (newValue && newValue.inputValue) {
          addNewItem(newValue.inputValue)
        } else {
          setValue(newValue);
        }
        if (props.resourceItem) {
          props.resourceItem();
        }
        if (props.show) {
          props.show();
        }
        props.selectedValue(newValue);
        setValue({
          value: "",
        });

      }}
      filterOptions={(options, params) => {
        const filtered = filter(options, params);
        // Suggest the creation of a new value
        if (params.inputValue !== '') {
          filtered.push({
            title: <span className={`add-button ${props.classes}`}><AddIcon /> Add "{params.inputValue}" as a new tag</span>,
            inputValue: params.inputValue,
          });
        }
        inputLength = params.inputValue.length;
        return filtered;
      }}
      clearOnBlur
      options={tempAllTags}
      getOptionLabel={(option) => {
        // Value selected with enter, right from the input
        if (typeof option === 'string') {
          return option;
        }
        // Add "xxx" option created dynamically
        if (option.inputValue) {
          return option.inputValue;
        }
        // Regular option
        return option.title;
      }}
      renderOption={(option, { inputValue }) => {
        const matches = match(option.title, inputValue);
        const parts = parse(option.title, matches);
        return (
          <div>
            {parts.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 300 }}>
                {capitalizeFirstLetter(part.text)}
              </span>
            ))}
          </div>
        );
      }}
      style={{ width: 170 }}
      renderInput={(params) => (
        <TextField className={`chipsInput ${inputLength > 30 && "error"}`} {...params} placeholder={props.title} />
      )}
    />
  );
}
